import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import NewPatientOnboarding from "./sections/NewPatientOnboarding";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <NewPatientOnboarding />
      <CommonQuestions />
      <Footer />
    </div>;
}